import {clearAddressPin, setAddressPin, setMapLocation} from './map';
import {getGeocode} from './geocoder';
import {getSuggestions} from './suggestions';

const header = document.getElementById('header');
const addressSearchForm = document.getElementById('address-search');
const suggestionsContainer = document.getElementById('suggestions');

export const addressSearchInput = addressSearchForm.querySelector('input');
export const addressSearchNumbers = document.getElementById(
  'address-search_numbers'
);

export function initSearchBox() {
  addressSearchInput.addEventListener('input', handleInput);
  addressSearchInput.addEventListener('change', handleInputReset);
  // addressSearchForm.addEventListener('submit', handleSubmit);
}

async function handleInput(event?) {
  if (event) {
    event.preventDefault();
  }

  const text = addressSearchInput.value;

  if (text && text.length > 2) {
    header.classList.add('active');
    const suggestions = await getSuggestions(text);
    initSuggestionsContainer(suggestions);
  } else {
    handleInputReset();
  }
}

function handleInputReset() {
  const text = addressSearchInput.value;

  if (!text.trim()) {
    header.classList.remove('active');
    addressSearchForm.classList.remove('active');
    clearAddressPin();
  }
}

async function handleSubmit(event) {
  if (event) {
    event.preventDefault();
  }

  const address = addressSearchInput.value;

  if (!address) {
    alert('Wo Adresse!?');
    addressSearchForm.reset();
    return;
  }

  const coordinates = await getGeocode(address);
  setMapLocation(coordinates.lat, coordinates.lng);
  header.classList.remove('active');
}

function initSuggestionsContainer(suggestions) {
  suggestionsContainer.innerHTML = '';

  // Events are attached too often, need to refactor
  // For every new suggestions result, new event listeners are attached,
  // resulting in adding multiple Marker instance on the map.
  // Or find a better way to rerender the suggestions, with clean clearing of
  // previous suggestions and events.
  suggestions.forEach(suggestion => {
    const address = suggestion.element.querySelector('.address');
    const button = suggestion.element.querySelector('button');

    suggestionsContainer.appendChild(suggestion.element);

    address.addEventListener('click', event => {
      event.preventDefault();
      addressSearchInput.value = suggestion.address;
      renderNumbers(suggestion);
    });

    button.addEventListener('click', event => {
      event.preventDefault();
      addressSearchInput.value = suggestion.address;
      renderNumbers(suggestion);
    });
  });

  addressSearchNumbers.addEventListener('change', event => {
    event.preventDefault();

    const number = event.target.value;

    if (number === 'Nr.') {
      return null;
    }

    const streetId = addressSearchInput.value;
    const coords = suggestions.find(s => s.streetId === streetId).addresses[
      number
    ];

    setAddressPin(coords.lat, coords.lng);
    setMapLocation(coords.lat, coords.lng);
  });
}

function renderNumbers(address) {
  header.classList.remove('active');
  addressSearchNumbers.innerHTML = '';
  addressSearchForm.classList.add('active');

  ['Nr.', ...address.numbers].forEach(number => {
    const numberEl = document.createElement('option');
    numberEl.innerText = number;

    if (number === 'Nr.') {
      numberEl.disabled = true;
      numberEl.selected = true;
    }

    addressSearchNumbers.appendChild(numberEl);
  });
}
